<template>
  <BlockContainer class="p-5">
    <ValidationObserver v-slot="{ invalid, dirty }">
      <div class="row align-items-center">
        <div class="col col-lg-8">
          <h5>Leieobjektets fasiliteter</h5>
        </div>

        <div class="col edit-buttons text-right">
          <div v-if="editMode">
            <CancelButton class="mr-1" @click.native="editMode = false" />
            <SaveButton
              :loading="loading"
              @click.native="patchRentalObject"
              :disabled="!dirty || invalid"
              class="ml-1"
            />
          </div>

          <EditButton v-else @click.native="setEditModeAndLocalCopy" />
        </div>
      </div>

      <div class="mt-5">
        <h6>Møblering</h6>

        <div v-if="loaded" class="mt-4">
          <ValidationProvider v-if="editMode">
            <hl-Select
              size="sm"
              :hasMarginBottom="false"
              v-model="localCopy.furnished"
              placeholder="Velg møblering"
              placeholderValue=""
              placeholderDisabled
              :options="furnishedStates"
              @input.native="setFurnished"
            ></hl-Select>
          </ValidationProvider>

          <span v-else>
            <span>{{ details.furnished }}</span>
          </span>
        </div>

        <hl-Mask v-else :width="140" :height="15"></hl-Mask>
      </div>

      <!-- Loading Mask -->
      <div v-if="!loaded" class="row mt-5">
        <div v-for="(count, i) in 10" :key="i" class="col-sm-12 col-xl-6 mb-4">
          <hl-Mask></hl-Mask>
          <hl-Mask class="ml-3" :width="110"></hl-Mask>
        </div>
      </div>
      <!-- Loading Mask -->

      <div v-else class="mt-5">
        <div v-if="editMode" class="row">
          <div v-for="(facility, i) in localCopy.facilities" :key="i" class="col-sm-12 col-xl-6">
            <ValidationProvider :name="`Fasiliteter ${facility.name}`">
              <hl-Checkbox size="sm" :label="mapFacilities(facility.name)" v-model="facility.checked"></hl-Checkbox>
            </ValidationProvider>
          </div>
        </div>

        <div v-else class="row">
          <div v-for="(facility, i) in details.facilities" :key="i" class="col-sm-12 col-xl-6">
            <div class="mb-3">
              <i v-if="facility.checked" class="budicon-solid budicon-solid-tick-sign text-primary"></i>
              <i v-else class="budicon-cross-sign text-secondary"></i>
              <span class="ml-4">{{ mapFacilities(facility.name) }}</span>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer.vue';
import CancelButton from '@/components/UI/buttons/CancelButton';
import EditButton from '@/components/UI/buttons/EditButton';
import SaveButton from '@/components/UI/buttons/SaveButton';
import { mapGetters } from 'vuex';
import { rentalObjectFacilityList as facilityList } from '@/lib/rentalObjectHelpers';
import Select from '@modules/husleie-framework/src/components/forms/inputs/select/Select.vue';
import Mask from '@modules/husleie-framework/src/components/loaders/Mask.vue';
import Checkbox from '@modules/husleie-framework/src/components/forms/inputs/checkbox/Checkbox.vue';

export default {
  components: {
    BlockContainer,
    CancelButton,
    EditButton,
    SaveButton,
    'hl-Select': Select,
    'hl-Mask': Mask,
    'hl-Checkbox': Checkbox,
  },

  props: {
    rentalObjectId: [Number, String],
  },

  data() {
    return {
      editMode: false,
      loading: false,
      localCopy: null,
      furnishedStates: [
        {
          name: 'Møblert',
          value: 'Møblert',
        },
        {
          name: 'Delvis Møblert',
          value: 'Delvis Møblert',
        },
        {
          name: 'Umøblert',
          value: 'Umøblert',
        },
      ],
      facilityList,
    };
  },

  computed: {
    ...mapGetters(['getRentalObject', 'isExtendedRentalObjectLoaded', 'isRentalObjectPatching']),

    details() {
      return this.getRentalObject(this.rentalObjectId).details;
    },

    loaded() {
      return this.isExtendedRentalObjectLoaded;
    },

    patching() {
      return this.isRentalObjectPatching;
    },

    patchBody() {
      return {
        details: {
          furnished: this.localCopy.furnished,
          facilities: this.localCopy.facilities,
        },
      };
    },
  },

  methods: {
    setEditModeAndLocalCopy() {
      this.editMode = true;
      this.$set(this, 'localCopy', JSON.parse(JSON.stringify(this.details)));
    },

    patchRentalObject() {
      this.loading = true;
      this.$store.dispatch('patchRentalObject', {
        rentalObjectId: this.rentalObjectId,
        body: this.patchBody,
        success: () => {
          this.editMode = false;
          this.$toast('Lagret', 'success');
        },
        error: () => {
          this.showErrorModal = true;
          this.$toast('Kunne ikke lagre', 'error');
        },
      });
      this.loading = false;
    },

    setFurnished(e) {
      this.$store.dispatch('updateFurnished', {
        rentalObjectId: this.rentalObjectId,
        furnished: this.mapFurnishedState(e.target.value),
      });
    },

    mapFurnishedState(state) {
      for (const i of this.furnishedStates) {
        if (i.value === state) {
          return i.name;
        }
      }
    },

    mapFacilities(type) {
      for (const i of this.facilityList) {
        if (i.value === type) {
          return i.name;
        }
      }
    },
  },
};
</script>
